import assign from 'lodash/assign';
import isUndefined from 'lodash/isUndefined';
import SHUtils from 'utils';
import SHSignals from 'sh-signals';
import DOMUtils from '@spothero/utils/dom';

var init = function init(extras) {
        assign(this, window.SHGlobals, extras);

        window.SHGlobals = this;
    },

    renderRecaptcha = function renderRecaptcha() {
        window.grecaptcha.render(DOMUtils.el('.g-recaptcha'), {
            sitekey: window.SHGlobals.recaptchaSiteKey,
            callback: SHSignals.recaptchaRespondedTo.dispatch
        });
    };

/**
 * Allows access to global properties and methods from anywhere within the application.
 * @module SHGlobals
 * @example
 * console.log(SHGlobals.API_PATH);
 */
module.exports = {
    init: init,
    stripeV2Loaded: false,

    /**
     * Path to the currently used version of the API.
     * @constant
     * @type {String}
     * @default '/api/v1'
     */
    API_PATH: '/api/v1',

    /**
     * Path to the currently used version of the Services API.
     * @constant
     * @type {String}
     * @default 'https://services.production.spothero.com'
     */
    SERVICE_API_PATH: window.SHGlobals.SERVICE_API_PATH || 'https://services.production.spothero.com',

    /**
     * Path to the Django static directory.
     * @constant
     * @type {String}
     * @default '/static'
     */
    STATIC_PATH: '/static',

    /**
     * The date format used in URLs.
     * @constant
     * @type {String}
     * @default 'MM-DD-YYYY'
     */
    URL_DATE_FORMAT: 'MM-DD-YYYY',

    /**
     * The time format used in URLs.
     * @constant
     * @type {String}
     * @default 'hhmmA'
     */
    URL_TIME_FORMAT: 'hhmmA',

    /**
     * The date format used on a native mobile device.
     * @constant
     * @type {String}
     * @default 'YYYY-MM-DD'
     */
    MOBILE_DATE_FORMAT: 'YYYY-MM-DD',

    /**
     * The date format used on desktop.
     * @constant
     * @type {String}
     * @default 'MM/DD/YYYY'
     */
    DESKTOP_DATE_FORMAT: 'MM/DD/YYYY',

    /**
     * The time format used on a native mobile device.
     * @constant
     * @type {String}
     * @default 'HH:mm'
     */
    MOBILE_TIME_FORMAT: 'HH:mm',

    /**
     * The time format used on desktop.
     * @constant
     * @type {String}
     * @default 'hh:mm A'
     */
    DESKTOP_TIME_FORMAT: 'hh:mm A',

    /**
     * The time format for interactions with the server.
     * @constant
     * @type {String}
     * @default 'YYYY-MM-DDTHH:mm'
     */
    SERVER_DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm',

    /**
     * The time, in milliseconds, to wait before closing a modal automatically.
     * @constant
     * @type {Number}
     * @default 3000
     */
    CLOSE_MODAL_DELAY: 3000,

    /**
     * The items to include when calling the Facility API endpoint.
     * @constant
     * @type {String}
     * @default The facility includes.
     */
    FACILITY_INCLUDES: 'inventory_availability,facility,facility.amenities_full,facility.details,facility.images,facility.vehicle_size,facility.oversize_description,facility.transient_available,facility.monthly_available,facility.vehicle_restriction_description,facility.oversize_vehicle_type,facility.rating_info,facility.facility_url,facility.supported_fee_types',

    /**
     * The list of credit cards that we accept as payment types.
     * @constant
     * @type {Array}
     * @default The accepted credit cards.
     */
    ACCEPTED_CREDIT_CARDS: ['visa', 'mastercard', 'maestro', 'american express', 'discover', 'diners club'],

    /**
     * Descriptive text for referral program incentive.
     * @constant
     * @type {String}
     * @default "Give $7, Get $7"
     */
    referralIncentiveMessage: 'Give $7, Get $7',

    /**
     * The site key to use for reCAPTCHA.
     * @constant
     * @type {String}
     * @default '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
     */
    recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',

    /**
     * Whether the site is running in staging/sandboxes (production inclusive) or locally.
     * @var {Boolean}
     * @default false
     */
    isDeployed: window.SHGlobals.isDeployed || false,

    /**
     * Whether the site is running in production ONLY or locally.
     * @var {Boolean}
     * @default false
     */
    isProduction: window.SHGlobals.isProduction || false,

    /**
     * Whether the site is running on the domain "spothero.com".
     * @var {Boolean}
     * @default false
     */
    isProductionDomain: window.SHGlobals.isProductionDomain || false,

    /**
     * Whether the current user is an admin user.
     * @var {Boolean}
     * @default false
     */
    isAdmin: window.SHGlobals.isAdmin || false,

    /**
     * Whether the currently running page is on a mobile device.
     * @var {Boolean}
     * @default false
     */
    isMobile: window.SHGlobals.isMobile || false,

    /**
     * Whether the current user appears to be a bot.
     * @var {Boolean}
     * @default false
     */
    isBot: window.SHGlobals.isBot || false,

    /**
     * Whether to use the native DatePicker.
     * @var {Boolean}
     * @default false
     */
    useNativeDatePicker: window.SHGlobals.useNativeDatePicker || false,

    /**
     * Reports the current date and time for the selected city.
     * @var {?String}
     * @default The date and time.
     */
    currentCityDateTime: window.SHGlobals.currentCityDateTime || null,

    /**
     * Reports the current time zone for the selected city.
     * @var {?String}
     * @default The time zone.
     */
    currentCityTimezone: window.SHGlobals.currentCityTimezone || null,

    /**
     * Whether or not segment is enabled.
     * @var {Boolean}
     * @default false.
     */
    isSegmentEnabled: window.SHGlobals.isSegmentEnabled || false,

    /**
     * The api key to use for segment.
     * @constant
     * @type {String}
     * @default 'DSBO42HVekfwO1joUX2uQ9h1kJDEzJKv'
     */
    segmentApiKey: window.SHGlobals.segmentApiKey || 'DSBO42HVekfwO1joUX2uQ9h1kJDEzJKv',

    /**
     * Viewer Country Code from Cloudfront Headers
     * @constant
     * @type {String}
     * @default null
     */
    cloudfrontViewerCountryCode: window.SHGlobals.cloudfrontViewerCountryCode || null,

    /**
     * Initializes the Stripe payment processor.
     * @static
     * @function initPaymentProcessor
     * @param {String} key The Stripe public API key.
     * @example
     * SHGlobals.initPaymentProcessor('key');
     * @returns {void}
     */
    initPaymentProcessor: function(key) {
        if (isUndefined(window.Stripe)) {
            // Don't use stripe if we're not connected to internet.
            return;
        }

        window.StripeV3 = window.Stripe(key);
        window.StripeElements = window.StripeV3.elements();
    },

    /**
     * Gathers the necessary Cloudinary transformations for dynamically creating images.
     * @static
     * @function cloudinaryTransformations
     * @param {Number} width The width to set the image to.
     * @param {Number} height The height to set the image to.
     * @example
     * SHGlobals.cloudinaryTransformations(180, 90);
     * @returns {Object} The transformations to set on the Cloudinary image.
     */
    cloudinaryTransformations: function(width, height) {
        return {
            width: width,
            height: height,
            crop: 'fill',
            dpr: (SHUtils.isHighDensityDisplay()) ? 2 : 1,
            flags: 'progressive',
            quality: 50,
            fetch_format: 'auto'
        };
    },

    initRecaptcha: function() {
        if (window.SHGlobals.isProductionDomain) {
            if (!window.grecaptcha) {
                window.onRecaptchaLoaded = function() {
                    renderRecaptcha();
                };
            } else {
                renderRecaptcha();
            }
        }
    }
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/global/common/sh-globals.js